import { ref } from 'vue'
import { defineStore } from 'pinia'
import { tenants, type Tenant } from '@/config/tenants'

export const useTenantStore = defineStore('tenant', () => {
  /* Bootstrap resolves the real tenant from the hostname before mount;
     the default only exists so the type is never null. */
  const current = ref<Tenant>(tenants.maluwilz)

  function setTenant(tenant: Tenant): void {
    current.value = tenant
  }

  return { current, setTenant }
})
